import { render, staticRenderFns } from "./perfoReportmouth.vue?vue&type=template&id=83c7eb20&"
import script from "./perfoReportmouth.vue?vue&type=script&lang=js&"
export * from "./perfoReportmouth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports